import script from "./object_video.vue?vue&type=script&setup=true&lang=js"
export * from "./object_video.vue?vue&type=script&setup=true&lang=js"

import "./object_video.vue?vue&type=style&index=0&id=2132d920&scoped=true&lang=scss"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2132d920"]])

export default __exports__